import { useEffect, useMemo, useState } from 'react';

import debounce from 'lodash/debounce';

import { ScheduledSemenItem } from '@/services/semen-pull';
import { useUpsertSireNoteMutation as useSireNoteMutation } from '@/services/sire-note';

type SireNoteCellParams = {
  data?: ScheduledSemenItem;
};

export function SireNoteCell({ data }: SireNoteCellParams) {
  const {
    sireId,
    donorScheduleId,
    accountId,
    semenType,
    semenId,
    colCode,
    sireNote = '',
  } = data || {};

  const [note, setNote] = useState(sireNote ?? '');
  useEffect(() => {
    const nextNote = sireNote ?? '';
    setNote(nextNote);
  }, [sireNote]);

  const { mutate } = useSireNoteMutation();
  const saveNote = useMemo(
    () =>
      debounce((nextNote: string) => {
        if (!sireId || !accountId || !donorScheduleId || semenType == null) {
          return;
        }

        mutate({
          sireId,
          semenId,
          donorScheduleId,
          accountId,
          collectionCode: colCode,
          semenType,
          note: nextNote,
        });
      }, 1_000),
    [accountId, colCode, donorScheduleId, mutate, semenId, semenType, sireId],
  );
  useEffect(() => {
    return () => saveNote.cancel();
  }, [saveNote]);

  return (
    <input
      className="disabled:bg-secondary h-full w-full rounded-[4px] border border-[#cccccc] bg-white px-1"
      disabled={!sireId || !accountId || !donorScheduleId || semenType == null}
      maxLength={500}
      type="text"
      value={note}
      onChange={(event) => {
        const nextNote = event.target.value;
        setNote(nextNote);
        saveNote(nextNote);
      }}
    />
  );
}
